export default __webpack_public_path__ + "static/logo.whw-2954485d76c6a5c2c525f5c4537f001f.png";